import { Box, Typography } from '@mui/material';

interface ComingSoonCardProps {
  title: string;
}
const ComingSoonCard: React.FC<ComingSoonCardProps> = (props) => {
  const { title } = props;
  return (
    <Box className="app-plain-card empty-content">
      <Typography variant="h2">{title}</Typography>
      <Typography variant="h6" className="text-gray">
        Coming Soon
      </Typography>
    </Box>
  );
};

export default ComingSoonCard;
